import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import { queryKeys } from '../queries/queryKeys';
import { attachmentsActions } from '../../../actions/attachments.actions';

const addDocsAttachFile = async ({ docId, attachId }) => {
  return await request.delete(
    `/Docs/deleteAttach?docId=${docId}&attachId=${attachId}`,
    null,
    'При удалении вложения произошла ошибка',
    'Error'
  );
};

const useDeleteDocsAttachFile = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(addDocsAttachFile, {
    onSuccess: (data, { docId }) => {
      if (data === 'Error') return;

      queryClient.invalidateQueries(queryKeys.docsAttachments(docId));
      attachmentsActions.fetchAttachments(docId, 'documents');
    },
  });

  return {
    isLoading: mutation.isLoading,
    onMutation: mutation.mutateAsync,
  };
};

export default useDeleteDocsAttachFile;
